import { Charts } from './Charts';
import GeneralResultsChartsDataProvider from './contexts/GeneralResultsChartsDataContext';

const GeneralResultsWrapper = () => {
    return (
        <GeneralResultsChartsDataProvider>
            <Charts />
        </GeneralResultsChartsDataProvider>
    );
};

export default GeneralResultsWrapper;
